export const en = {
    "button-save": "Save",
    "checkbox-private": "Private dialog",
    "description-name": "The name of the dialog by which it can be launched. Use the command \"Give the sound\". For example, \"Give me the sound of my synthesizer\".",
    "description-privacy": "If selected, the dialog can only be started from your account.",
    "description-private-only": "At the moment, only private skills can be created",
    "description-sounds": "Load from two to six sounds — they will be evenly distributed in height. The melody will be played depending on the number of sounds and the position of the hand. The order of the sounds can be changed on this page.",
    "dial-option-not-play": "Do not play the previous sound over the next one",
    "dial-option-repeat": "Repeat the sound while the hand is over the speaker",
    "dial-option-stop": "Stop the sound when the hand is removed",
    "error": "An error has occurred",
    "error-form": "Errors were found when checking the form.",
    "header-settings": "Main settings",
    "header-sounds": "Sounds",
    "label-dial-settings": "Dial Settings",
    "label-set": "Set",
    "select-sounds": "Select sounds",
    "sounds-format": "The format of the sounds is mp3, the size of each is up to 150 KB.",
    "testing": "Test it"
} as const;
export const ru = {
    "button-save": "Сохранить",
    "checkbox-private": "Приватный диалог",
    "description-name": "Название диалога, по которому его можно будет запускать. Используйте команду «Дай звук». Например, «Дай звук моего синтезатора».",
    "description-privacy": "Если выбрано, то запускать диалог можно будет только с вашего аккаунта.",
    "description-private-only": "На данный момент доступно создание только приватных навыков",
    "description-sounds": "Загрузите от двух до шести звуков — они равномерно распределятся по высоте. Мелодия будет проигрываться в зависимости от числа звуков и положения руки. Порядок звуков можно будет изменить на этой странице.",
    "dial-option-not-play": "Не проигрывать предыдущий звук поверх следующего",
    "dial-option-repeat": "Повторять звук, пока рука над колонкой",
    "dial-option-stop": "Останавливать звук, когда руку убрали",
    "error": "Произошла ошибка",
    "error-form": "При проверке формы обнаружены ошибки.",
    "header-settings": "Основные настройки",
    "header-sounds": "Звуки",
    "label-dial-settings": "Настройки набора",
    "label-set": "Набор",
    "select-sounds": "Выбрать звуки",
    "sounds-format": "Формат звуков — mp3, размер каждого — до 150 КБ.",
    "testing": "Протестировать"
} as const;